<script setup lang="ts">
import {HomeIcon} from '@heroicons/vue/24/outline'
</script>

<template>
  <div class="page-header">
    <router-link to="/">
      <HomeIcon aria-hidden="true" class="h-8 w-8 homeicon"/>
    </router-link>
  </div>
</template>

<style scoped>

</style>